import { Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { FORM_FIELDS } from 'src/const-data/form-field-mappings';
import { FormFieldDropdowns } from 'src/const-data/form-field-dropdowns';
import { ValidationFeedback } from 'src/const-data/validation-feedback';

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.css'],
  standalone: false
})
export class BasicInfoComponent implements OnChanges {
  @Output()
  readonly onStepForward: EventEmitter<void> = new EventEmitter();
  @Output()
  readonly simpleCalculation: EventEmitter<boolean> = new EventEmitter();
  @Input()
  basisInfoForm!: FormGroup;
  @Input()
  projectId!: string;
  protected readonly validationFeedback = ValidationFeedback;
  protected readonly fields = FORM_FIELDS.BASIS_INFO;

  protected readonly dropdowns = FormFieldDropdowns.dropDowns;
  private readonly destroyRef = inject(DestroyRef);

  private lastLoadedProjectId: string | null = null;
  private lastLoadedForm: FormGroup | null = null;

  constructor(private readonly dataService: DataService) {}

  changeSimpleSelection() {
    const simpleCalcValue = this.basisInfoForm.controls[this.fields.SIMPLE_CALC].value;
    const simpleCalcSelected = simpleCalcValue !== 'No';

    this.simpleCalculation.emit(simpleCalcSelected);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectId'] || changes['basisInfoForm']) {
      this.tryLoadProjectData();
    }
  }

  private tryLoadProjectData(): void {
    const id = (this.projectId ?? '').trim();
    const form = this.basisInfoForm;
    if (!id || !form) return;
    if (this.lastLoadedProjectId === id && this.lastLoadedForm === form) return;

    this.lastLoadedProjectId = id;
    this.lastLoadedForm = form;

    this.dataService
      .readData(form, id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          // Data loaded successfully
        },
        error: () => {
          // Error already handled by DataTransferService with toast notification
        }
      });
  }

  nextStep() {
    this.onStepForward.emit();
  }
}
